import { RefObject, useEffect, useState } from 'react';

export const useVisibleSpaceBelow = (
  ref: RefObject<HTMLElement>,
  active: boolean,
) => {
  const [space, setSpace] = useState<number>();

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!active || !viewport) return;

    const measure = () => {
      const bottom = ref.current?.getBoundingClientRect().bottom;
      if (bottom !== undefined)
        setSpace(viewport.offsetTop + viewport.height - bottom);
    };

    measure();
    viewport.addEventListener('resize', measure);
    document.addEventListener('scroll', measure, true);
    return () => {
      viewport.removeEventListener('resize', measure);
      document.removeEventListener('scroll', measure, true);
    };
  }, [ref, active]);

  return active ? space : undefined;
};
